import { render, staticRenderFns } from "./EmployeeCards_Form.vue?vue&type=template&id=bf31ded6&scoped=true&"
import script from "./EmployeeCards_Form.vue?vue&type=script&lang=js&"
export * from "./EmployeeCards_Form.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCards_Form.vue?vue&type=style&index=0&id=bf31ded6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf31ded6",
  null
  
)

export default component.exports